'use client';

import Container from '@/app/_components/container/Container';
import Heading from '@/app/_components/common/heading/Heading';

import Text from '@/app/_components/common/text/Text';
import Button from '@/app/_components/common/button/Button';
import styles from '@/app/(pages)/main/main.module.scss';
import IconArrowForward from '@/app/_images/ico_arrow_forward.svg';
import { useLoggedInStore } from '@/app/_stores/loggedInStore';
import Link from 'next/link';
import { ROUTER_PATH } from '@/app/_contants/routerPath';

export default function SectionKeyVisual() {
  const { isLoggedIn } = useLoggedInStore();

  return (
    <section className={`${styles.section} ${styles.keyVisual}`}>
      <Container className={styles.textHolder}>
        <div className={styles.innerBox}>
          <div className={styles.titleBox}>
            <Heading className={styles.title}>
              <span className={styles.iconGpt}></span>
              <span>
                <span className={'text-primary'}>生成AI</span>が作成した文書の<span className={'text-primary'}>検出</span>
              </span>
            </Heading>
            <Text>
              GPT Killer（GPTキラー）は、日本語に特化した生成AI検出ツールです。
              <br />
              教育、学術、業務プロセスで発生する生成AIの弊害を防ぎましょう。
            </Text>
          </div>
          <div className={styles.btnArea}>
            <Link href={isLoggedIn ? '/results' : ROUTER_PATH.LOGIN}>
              <Button>
                無料で始める
                <IconArrowForward />
              </Button>
            </Link>
          </div>
        </div>
      </Container>
      <Container className={styles.bg}>
        <div className={styles.innerBox}>
          <img
            src="/images/main/bg_keyvisual.png"
            srcSet="/images/main/bg_keyvisual.png 1300w,  /images/main/bg_keyvisual@m.png 600w"
            sizes="(max-width: 767px) 200px"
            alt=""
          />
        </div>
      </Container>
      <div className={styles.marquee}>
        <div className={styles.marqueeInner}>
          <div>AI検出・AIバイパスツール GPT Killer</div>
          <div>AI検出・AIバイパスツール GPT Killer</div>
          <div>AI検出・AIバイパスツール GPT Killer</div>
          <div>AI検出・AIバイパスツール GPT Killer</div>
        </div>
      </div>
    </section>
  );
}
